import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	font-size: 18px;
	margin-top: 20px;
`;

export const Mine = styled.div`
	flex: 1;
	text-align: left;
`;

export const ButtonWrapper = styled.div`
	flex: 1;
	text-align: center;
`;

export const RestartButton = styled.span`
	cursor: pointer;
`;

export const SettingsButton = styled.span`
	cursor: pointer;
`;

export const Timer = styled.div`
	flex: 1;
	text-align: right;
`;